<template>
  <div class="build-content">
    <div class="build-null" v-if="buildList.length==0">
      <img src="../assets/images/modeling_build.png" alt />
      <p>暂无模型，请返回添加</p>
    </div>
    <ul class="clearfloat" v-else style="height: 100%;overflow: auto;">
      <li v-for="item in buildList" @click="getDataById(item.ID)" :key="item.ID">
        <a @click="removeBuild($event,item.ID)">×</a>
        <img src="../assets/images/modeling_build.png" alt />
        <h3 style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.Name}}</h3>
        <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{item.Remarks}}</p>
        <button @click="editBuild($event,item)">编辑模型</button>
      </li>  
    </ul>
    <a class="return-btn" style="bottom:130px;" @click="resetLastLoadData">清除</a>
    <a class="return-btn" @click="returnBtn">返回</a>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import BuildService from "../api/BuildService";
export default {
  inject: ["reload"],
  data() {
    return {
      buildList: []
    };
  },
  mounted() {
    BuildService.getAllList().then(
      res => {
        if (res.status == 200 && res.data.status == 1000) {
          this.buildList = res.data.data;
        } else if (res.status == 200) {
          this.$message.warning(res.data.msg);
        } else {
          this.$message.warning(res.message);
        }
      },
      err => {
        this.$message.warning(err.message);
      }
    ); 
    sessionStorage.setItem('isBuildList',true)
  },
  methods: {
    returnBtn(){
      sessionStorage.removeItem('isBuildList')
      //this.$router.go(-1)
      this.$router.push({
          name:'builds'
        }).catch(err => {console.error(err)})
    },
    getDataById(id) {  
      BuildService.getJsonDataById({ ID: id }).then(
        res => {
          if (res.status == 200 && res.data.status == 1000) {
            //根据id获取到楼层信息之后需要再次把楼层信息发送给后台保存最新的楼层  
            BuildService.saveLastLoadData({jsondata:res.data.data.JsonData}).then( 
              res=>{
                if (res.status == 200 && res.data.status == 1000) { 
                  this.$router.push({
                    name: "home",
                    params:{
                      floorData:res.data.data
                    }
                  }).catch(err => {console.error(err)});
                } else if (res.status == 200) {
                  this.$message.warning(res.data.msg);
                } else {
                  this.$message.warning(res.message);
                }
              },
              err=>{
                this.$message.warning(err.message);
              }
            ) 
            
          } else if (res.status == 200) {
            this.$message.warning(res.data.msg);
          } else {
            this.$message.warning(res.message);
          }
        },
        err => {
          this.$message.warning(err.message);
        }
      );
    },
    removeBuild(e, id) {
      e.stopPropagation();
      let that = this;
      this.$confirm({
        title: "提示",
        content: "是否删除",
        centered: true,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          BuildService.deleteBuildById({ id: id }).then(
            res => {
              if (res.status == 1000) {
                that.$message.success("删除成功");
                that.reload();
              } else {
                that.$message.warning(res.message);
              }
            },
            err => {
              that.$message.warning(err.message);
            }
          );
        }
      });
    },
    editBuild(e, item) {
      e.stopPropagation();
      this.$router.push({
        name: "buildMake",
        query: {
          type: "map",
          id: item.ID,
          Name: item.Name,
          Remarks: item.Remarks
        }
      }).catch(err => {console.error(err)});
    },
    resetLastLoadData(){
      BuildService.ResetLastLoadData().then(
        res => {
          if (res.status == 1000) {
            this.$message.success("清除成功"); 
          } else {
            this.$message.warning(res.message);
          }
        },
        err => {
          this.$message.warning(err.message);
        }
      );
    }
  },
  beforeDestroy(){
     
  }
}
</script>

<style scoped lang="less">
.build-content {
  display: table;
  width: 100%;
  background: #dddce2;
  height: 100vh;
  li {
    cursor: pointer;
    text-align: center;
    position: relative;
    float: left;
    width: 200px;
    height:360px;
    margin: 20px 30px;
    padding: 30px 0;
    a {
      position: absolute;
      width: 30px;
      height: 30px;
      line-height: 21px;
      text-align: center;
      top: 0;
      right: 0;
      font-size: 35px;
      color: #fff;
      background: #404751;
      border-radius: 50%;
    }
    img {
      width: 80%;
    }
    h3 {
      font-size: 20px;
      padding: 10px 0;
    }
    p {
      font-size: 16px;
    }
    button {
      background: #40dc23;
      color: #fff;
      border: 0;
      padding: 5px 27px;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.return-btn {
  display: block;
  position: absolute;
  right: 30px;
  bottom: 30px;
  width: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 18px;
  color: #fff;
  background: #40dc23;
  border-radius: 50%;
}
.build-null {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  p {
    font-size: 20px;
    padding-top: 30px;
  }
}
</style>